type Props = {
  value: string;
  onChange: (v: string) => void;
  onSubmit?: () => void;
  maxLength?: number;
};

const ROWS = [
  ["Q","W","E","R","T","Y","U","I","O","P"],
  ["A","S","D","F","G","H","J","K","L","Ñ"],
  ["Z","X","C","V","B","N","M"],
];

export function BigKeyboard({ value, onChange, onSubmit, maxLength = 24 }: Props) {
  const press = (k: string) => {
    if (value.length >= maxLength) return;
    onChange(value + k);
  };
  const back = () => onChange(value.slice(0, -1));
  const space = () => press(" ");
  const canSubmit = value.trim().length >= 2;

  return (
    <div className="w-full max-w-3xl mx-auto select-none">
      {/* row 1 */}
      <div className="grid grid-cols-10 gap-1.5">
        {ROWS[0].map((k) => <Key key={k} onClick={() => press(k)}>{k}</Key>)}
      </div>
      {/* row 2 */}
      <div className="grid grid-cols-10 gap-1.5 mt-1.5">
        {ROWS[1].map((k) => <Key key={k} onClick={() => press(k)}>{k}</Key>)}
      </div>
      {/* row 3 */}
      <div className="grid grid-cols-9 gap-1.5 mt-1.5">
        <Key onClick={back} className="col-span-1 bg-ink/5">
          <BackIcon />
        </Key>
        {ROWS[2].map((k) => <Key key={k} onClick={() => press(k)}>{k}</Key>)}
        <Key onClick={onSubmit} disabled={!canSubmit} className={`col-span-1 ${canSubmit ? "bg-mezcal text-paper border-mezcal" : "bg-ink/10 text-ink/30"}`}>
          <span className="font-sans text-base font-bold tracking-wide">OK</span>
        </Key>
      </div>
      {/* row 4: space */}
      <div className="grid grid-cols-9 gap-1.5 mt-1.5">
        <div />
        <button
          onClick={space}
          className="col-span-7 h-14 rounded-md bg-paper border-2 border-ink/20 active:bg-ink active:text-paper active:scale-[0.98] transition shadow-sm font-sans text-sm tracking-widest text-ink/60"
        >
          ESPACIO
        </button>
        <div />
      </div>
    </div>
  );
}

function Key({
  children, onClick, className = "", disabled = false,
}: { children: React.ReactNode; onClick?: () => void; className?: string; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`h-14 rounded-md bg-paper border-2 border-ink/20 font-display font-bold text-2xl active:bg-ink active:text-paper active:scale-[0.94] transition shadow-sm flex items-center justify-center disabled:active:scale-100 ${className}`}
    >
      {children}
    </button>
  );
}

function BackIcon() {
  return (
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 1 L1 9 L7 17 L21 17 L21 1 Z" />
      <line x1="11" y1="6" x2="17" y2="12" />
      <line x1="17" y1="6" x2="11" y2="12" />
    </svg>
  );
}
